<template>
  <app-modal
    :size="size"
    @close="handleClickClose()"
  >
    <template #body>
      <session-forms
        :tab="tab"
        @authenticated="handleClickClose()"
      />
    </template>
  </app-modal>
</template>

<script setup>
import AppModal from '&/organisms/AppModal'
import SessionForms from '&/modules/sessions/SessionForms'

const emit = defineEmits(['close'])

defineProps({
  tab: { type: String, default: 'register' },
  size: { type: String, default: 'sm' }
})

const handleClickClose = () => emit('close')
</script>

<style lang="scss" scoped>
:deep() {
  .modal {
    &__container {
      width: min(628px, 100%);
    }

    &__body {
      padding: 24px;
    }
  }
}
</style>